(function () {
  'use strict';

  if (window.__kfaMobileGridLightboxLoaded) return;
  window.__kfaMobileGridLightboxLoaded = true;

  var mobileTouch = window.matchMedia
    ? window.matchMedia('(max-width: 1024px) and (pointer: coarse)')
    : null;

  var lightbox = null;
  var lightboxImage = null;
  var lastTrigger = null;
  var previousBodyOverflow = '';

  function isMobileTouch() {
    return !mobileTouch || mobileTouch.matches;
  }

  function highestResolutionSource(img) {
    var srcset = img.getAttribute('srcset');
    if (!srcset) return img.currentSrc || img.src;

    var bestUrl = '';
    var bestWidth = 0;

    srcset.split(',').forEach(function (candidate) {
      var part = candidate.trim();
      var match = part.match(/^(.*)\s+(\d+)w$/);
      if (!match) return;

      var width = parseInt(match[2], 10);
      if (width > bestWidth) {
        bestWidth = width;
        bestUrl = match[1].trim();
      }
    });

    return bestUrl || img.currentSrc || img.src;
  }

  function eligibleImage(target) {
    if (!target || !target.closest) return null;

    var img = target.closest('.okd-grid__tiles .tile img');
    if (!img) return null;

    var tile = img.closest('.okd-grid__tiles .tile');
    if (!tile) return null;

    /* Existing linked/product tiles retain their current navigation behaviour. */
    if (tile.querySelector('a[href]')) return null;

    return img;
  }

  function buildLightbox() {
    if (lightbox) return;

    lightbox = document.createElement('div');
    lightbox.className = 'kfa-mobile-grid-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Image detail');

    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'kfa-mobile-grid-lightbox__close';
    closeButton.setAttribute('aria-label', 'Close image');
    closeButton.textContent = '×';

    lightboxImage = document.createElement('img');
    lightboxImage.className = 'kfa-mobile-grid-lightbox__image';
    lightboxImage.alt = '';

    lightbox.appendChild(closeButton);
    lightbox.appendChild(lightboxImage);
    document.body.appendChild(lightbox);

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeLightbox();
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
  }

  function openLightbox(img) {
    buildLightbox();

    lastTrigger = img;
    lightboxImage.src = highestResolutionSource(img);
    lightboxImage.alt = img.alt || '';

    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    lightbox.classList.add('is-open');
  }

  function closeLightbox() {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;

    lightbox.classList.remove('is-open');
    document.body.style.overflow = previousBodyOverflow;

    window.setTimeout(function () {
      if (lightboxImage) lightboxImage.removeAttribute('src');
    }, 200);

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  document.addEventListener('click', function (event) {
    if (!isMobileTouch()) return;

    var img = eligibleImage(event.target);
    if (!img) return;

    event.preventDefault();
    event.stopPropagation();
    openLightbox(img);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
})();
